var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-list"},[_c('page-list',{ref:"pageList",attrs:{"list":_vm.list,"columns":_vm.columns,"export-data-options":_vm.exportDataOptions,"show-page":false,"refresh-method":_vm.refresh,"enable-virtual-scroll":_vm.enableVirtualScroll,"default-search-key":"obj_name","single-actions":_vm.singleActions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }